// tslint:disable:max-line-length
import * as React from 'react';

export const AuthenticateMotivationIcon = () => {
  return (
    // oxlint-disable-next-line react/forbid-elements
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 174 108">
      <g fill="none" fillRule="evenodd">
        <path
          fill="#E84260"
          d="M63.95 69.697A21.033 21.033 0 0 1 58 54.994C58 43.399 67.306 34 78.786 34c7.16 0 13.476 3.657 17.214 9.222C99.738 37.657 106.053 34 113.214 34 124.694 34 134 43.4 134 54.994c0 5.725-2.27 10.916-5.95 14.703L96 107 63.95 69.697z"
        />
        <path
          stroke="var(--theme-black)"
          strokeWidth="2"
          d="M59.95 68.697A21.033 21.033 0 0 1 54 53.994C54 42.399 63.306 33 74.786 33c7.16 0 13.476 3.657 17.214 9.222C95.738 36.657 102.053 33 109.214 33 120.694 33 130 42.4 130 53.994c0 5.725-2.27 10.916-5.95 14.703L92 106 59.95 68.697z"
        />
        <path
          fill="#2B87DB"
          d="M74.563 69.438h8.37c3.35 0 6.067 2.687 6.067 6.003v.462c0 3.315-2.716 6.003-6.067 6.003h-8.37v8.86a6.234 6.234 0 0 1-12.47 0v-8.86h-9.026c-3.35 0-6.067-2.688-6.067-6.003v-.462c0-3.316 2.716-6.004 6.067-6.004h9.027v-8.203a6.234 6.234 0 0 1 12.468 0v8.203z"
        />
        <path
          stroke="var(--theme-black)"
          strokeWidth="2"
          d="M78.933 69.438h-9.37v-9.204a5.234 5.234 0 1 0-10.47 0v9.203H49.068c-2.8 0-5.067 2.243-5.067 5.004v.462c0 2.76 2.266 5.003 5.067 5.003h10.027v9.86a5.234 5.234 0 1 0 10.468 0v-9.86h9.371c2.8 0 5.067-2.242 5.067-5.003v-.462c0-2.761-2.266-5.004-5.067-5.004z"
        />
        <path
          fill="#E84260"
          d="M16.407 31.302l-4.039 7.461-4.038-7.461-7.462-4.039 7.462-4.038 4.038-7.462 4.039 7.462 7.461 4.038zm121.599-19.296l-2.985 5.515-2.985-5.515-5.515-2.985 5.515-2.985L135.02.52l2.985 5.515 5.515 2.985zm28.296 63.296l-4.039 7.461-4.038-7.461-7.462-4.039 7.462-4.038 4.038-7.462 4.039 7.462 7.461 4.038z"
        />
      </g>
    </svg>
  );
};
